import { TResolutionTab } from './types';

const NEW_COMMENT_ID = 'NEW';
export const SELECTION_MARK_NAME = 'selection-mark';
export const SELECTION_NODE_NAME = 'selection-node';

const MORE_BUTTON_OPTION_KEYS = Object.freeze({
  // Comments
  EDIT_COMMENT: 'edit-comment',
  EDIT_REPLY: 'edit-reply',

  // Replies
  ARCHIVE_COMMENT: 'archive-comment',
  ARCHIVE_REPLY: 'archive-reply',
});

const MORE_BUTTON_OPTION_LABELS = Object.freeze({
  // Comments
  EDIT_COMMENT: 'Edit comment',
  EDIT_REPLY: 'Edit reply',

  // Replies
  ARCHIVE_COMMENT: 'Delete comment',
  ARCHIVE_REPLY: 'Delete reply',
});

const CARD_TEXTAREA_PLACEHOLDER = '@mention or reply';

const COMMENTS_HTML_ATTRIBUTES = Object.freeze({
  COMMENT_ID: 'data-comment-id',
  COMMENT_CONTAINER_ID: 'data-comment-container-id',
});

const COMMENT_RESOLUTION_TABS: TResolutionTab[] = [
  { value: 'unresolved-tab', text: 'Unresolved' },
  { value: 'resolved-tab', text: 'Resolved' },
];

// Constants for class names used in the react-mentions components
const MENTIONS_ROOT_CLASSNAME = 'mentions_root';

// eslint-disable-next-line react-refresh/only-export-components
const MENTIONS_CHILD_CLASSNAMES = Object.freeze({
  CONTROL: `.${MENTIONS_ROOT_CLASSNAME}__control`,
  HIGHLIGHTER: `.${MENTIONS_ROOT_CLASSNAME}__highlighter`,
  INPUT: `.${MENTIONS_ROOT_CLASSNAME}__input`,
  SUGGESTIONS: `.${MENTIONS_ROOT_CLASSNAME}__suggestions`,
  SUGGESTIONS_ITEM: `.${MENTIONS_ROOT_CLASSNAME}__suggestions__item`,
  SUGGESTIONS_ITEM_FOCUSED: `.${MENTIONS_ROOT_CLASSNAME}__suggestions__item--focused`,
});

export {
  NEW_COMMENT_ID,
  MORE_BUTTON_OPTION_KEYS,
  MORE_BUTTON_OPTION_LABELS,
  CARD_TEXTAREA_PLACEHOLDER,
  COMMENTS_HTML_ATTRIBUTES,
  COMMENT_RESOLUTION_TABS,
  MENTIONS_CHILD_CLASSNAMES,
  MENTIONS_ROOT_CLASSNAME,
};
